export const QUERY_KEYS = {
  CATEGORY_LIST: 'categoryList',
  COUNTRIES_LIST: 'countriesList',
  INTERESTS_LIST: 'interestsList',
  LOCATION_LIST: 'locationList',
  NFT_DETAILS: 'nftDetails',
  NFTS_LIST: 'nftsList',
  OFFER_DETAILS: 'offerDetails',
  OFFERS_LIST: 'offersList',
  POINTS_HISTORY: 'pointsHistory',
  PURCHASE_HISTORY: 'purchaseHistory',
  REDEEMED_COUPONS: 'redeemedCoupons',
  STATES_LIST: 'statesList',
  CITIES_LIST: 'citiesList',
  USER_DISCOUNTS_LIST: 'userDiscountsList',
  USER: 'user',
}
